import React from 'react';
import { createRoot } from "react-dom/client";
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/main.scss';

// Suppress opaque cross-origin third-party script errors (e.g. NoPaperForms widgets/trackers)
// from triggering Create React App's development error overlay modal ("Script error.").
if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (e) => {
      if (e.message === "Script error." || e.message === "Script error" || !e.filename) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true
  );
  window.addEventListener(
    "unhandledrejection",
    (e) => {
      if (e.reason && (e.reason.message === "Script error." || e.reason.message === "Script error")) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true
  );
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
